// Generated by scripts/gen-replay-safe.mjs from the API OpenAPI document (`pnpm gen:api`). Do not edit.
/** Operations the API deduplicates by `Idempotency-Key` (OpenAPI `x-replay-safe`): safe to replay after a transport failure. */
export const REPLAY_SAFE_OPERATIONS: readonly string[] = [
  'DELETE /v1/approval-pin/members/{id}',
  'DELETE /v1/bills/{id}/points',
  'DELETE /v1/bills/{id}/stamps-reward',
  'DELETE /v1/branches/{id}',
  'DELETE /v1/branches/{id}/closures/{childId}',
  'DELETE /v1/branches/{id}/resources/{childId}',
  'DELETE /v1/channel-accounts/{id}',
  'DELETE /v1/channels/meta/{id}',
  'DELETE /v1/checklists/{id}',
  'DELETE /v1/clinical/codes/{id}',
  'DELETE /v1/clinical/records/{id}',
  'DELETE /v1/clinical/templates/{id}',
  'DELETE /v1/customer-tags/{id}',
  'DELETE /v1/customers/{id}',
  'DELETE /v1/customers/{id}/health',
  'DELETE /v1/customers/{id}/notes/{noteId}',
  'DELETE /v1/finance/entries/{id}',
  'DELETE /v1/goals',
  'DELETE /v1/inventory/categories/{id}',
  'DELETE /v1/inventory/products/{id}',
  'DELETE /v1/members/{id}/pin',
  'DELETE /v1/online-booking/rich-menu',
  'DELETE /v1/package-products/{id}',
  'DELETE /v1/platform/accounting/contacts/{id}',
  'DELETE /v1/platform/accounting/documents/{id}',
  'DELETE /v1/platform/accounting/expense-categories/{id}',
  'DELETE /v1/platform/accounting/expenses/{id}',
  'DELETE /v1/platform/accounting/items/{id}',
  'DELETE /v1/platform/assignments/{tenantId}/{userId}/{role}',
  'DELETE /v1/platform/audits/{id}/findings/{findingId}',
  'DELETE /v1/platform/invoices/{id}',
  'DELETE /v1/platform/tenants/{id}/demo-data',
  'DELETE /v1/positions/{id}',
  'DELETE /v1/push-subscriptions',
  'DELETE /v1/rentals/blocklist/{id}',
  'DELETE /v1/roles/{id}',
  'DELETE /v1/schedule-blocks/{id}',
  'DELETE /v1/service-categories/{id}',
  'DELETE /v1/services/{id}',
  'DELETE /v1/shift-templates/{id}',
  'DELETE /v1/shifts/{id}',
  'DELETE /v1/skills/{id}',
  'DELETE /v1/sops/{id}',
  'DELETE /v1/staff-line-link',
  'DELETE /v1/surveys/{id}',
  'DELETE /v1/time-off/{id}',
  'PATCH /v1/ai-chat/inbox/settings',
  'PATCH /v1/ai-chat/settings',
  'PATCH /v1/appointments/{id}',
  'PATCH /v1/bills/{id}',
  'PATCH /v1/bills/{id}/items/{itemId}',
  'PATCH /v1/branches/{id}',
  'PATCH /v1/branches/{id}/resources/{childId}',
  'PATCH /v1/channel-accounts/{id}',
  'PATCH /v1/checklist-runs/{id}/items/{itemId}',
  'PATCH /v1/checklists/{id}',
  'PATCH /v1/clinical/codes/{id}',
  'PATCH /v1/clinical/plans/{id}',
  'PATCH /v1/clinical/records/{id}',
  'PATCH /v1/clinical/settings',
  'PATCH /v1/clinical/templates/{id}',
  'PATCH /v1/customer-complaints/{id}',
  'PATCH /v1/customer-tags/{id}',
  'PATCH /v1/customers/{id}',
  'PATCH /v1/customers/{id}/consent',
  'PATCH /v1/customers/{id}/notes/{noteId}',
  'PATCH /v1/field-definitions/{id}',
  'PATCH /v1/finance/categories/{id}',
  'PATCH /v1/finance/entries/{id}',
  'PATCH /v1/inventory/categories/{id}',
  'PATCH /v1/inventory/products/{id}',
  'PATCH /v1/inventory/settings',
  'PATCH /v1/inventory/suppliers/{id}',
  'PATCH /v1/members/{id}',
  'PATCH /v1/message-templates/{id}',
  'PATCH /v1/offboardings/{id}',
  'PATCH /v1/package-products/{id}',
  'PATCH /v1/platform/accounting/contacts/{id}',
  'PATCH /v1/platform/accounting/expense-categories/{id}',
  'PATCH /v1/platform/accounting/items/{id}',
  'PATCH /v1/platform/audits/{id}',
  'PATCH /v1/platform/audits/{id}/findings/{findingId}',
  'PATCH /v1/platform/engagement-tasks/{id}',
  'PATCH /v1/platform/engagements/{id}',
  'PATCH /v1/platform/invoices/{id}',
  'PATCH /v1/platform/leads/{id}',
  'PATCH /v1/platform/page-inbox/conversations/{id}',
  'PATCH /v1/platform/page-inbox/settings',
  'PATCH /v1/platform/plans/{id}',
  'PATCH /v1/platform/sales-ai/leads/{id}',
  'PATCH /v1/platform/sales-ai/replies/{id}',
  'PATCH /v1/platform/support-cases/{id}',
  'PATCH /v1/platform/team/{id}',
  'PATCH /v1/platform/tenants/{id}',
  'PATCH /v1/platform/tenants/{id}/ai-chat',
  'PATCH /v1/platform/tenants/{id}/meta-channels',
  'PATCH /v1/positions/{id}',
  'PATCH /v1/question-bank/{id}',
  'PATCH /v1/rentals/{id}',
  'PATCH /v1/roles/{id}',
  'PATCH /v1/service-categories/{id}',
  'PATCH /v1/service-records/{id}',
  'PATCH /v1/services/{id}',
  'PATCH /v1/shift-templates/{id}',
  'PATCH /v1/shifts/{id}',
  'PATCH /v1/skills/{id}',
  'PATCH /v1/sops/{id}',
  'PATCH /v1/surveys/{id}',
  'PATCH /v1/table-orders/items/{itemId}',
  'PATCH /v1/tenant',
  'PATCH /v1/vacation-tests/{id}',
  'POST /v1/action-approvals/{id}/cancel',
  'POST /v1/action-approvals/{id}/decide',
  'POST /v1/ai-chat/inbox/images/{id}/prepare',
  'POST /v1/ai-chat/inbox/messages/{id}/retry',
  'POST /v1/ai-chat/inbox/{id}/create-customer',
  'POST /v1/ai-chat/inbox/{id}/link-customer',
  'POST /v1/ai-chat/inbox/{id}/read',
  'POST /v1/ai-chat/inbox/{id}/reply',
  'POST /v1/ai-chat/inbox/{id}/status',
  'POST /v1/ai-chat/messages/{id}/flag',
  'POST /v1/ai-chat/pause',
  'POST /v1/ai-chat/test',
  'POST /v1/ai-chat/topup-request',
  'POST /v1/anon-reports/{id}/assign',
  'POST /v1/anon-reports/{id}/messages',
  'POST /v1/anon-reports/{id}/status',
  'POST /v1/appointments',
  'POST /v1/appointments/{id}/complete',
  'POST /v1/appointments/{id}/status',
  'POST /v1/approvals/{id}/decide',
  'POST /v1/assistant/cases',
  'POST /v1/auth/pin-switch',
  'POST /v1/billing/checkout',
  'POST /v1/billing/invoices/{id}/receipt',
  'POST /v1/bills',
  'POST /v1/bills/{id}/approvals/{approvalId}/cancel',
  'POST /v1/bills/{id}/approvals/{approvalId}/decide',
  'POST /v1/bills/{id}/discount',
  'POST /v1/bills/{id}/payments',
  'POST /v1/bills/{id}/points',
  'POST /v1/bills/{id}/receipt/send',
  'POST /v1/bills/{id}/refund',
  'POST /v1/bills/{id}/reissue',
  'POST /v1/bills/{id}/stamps-reward',
  'POST /v1/bills/{id}/void',
  'POST /v1/branches',
  'POST /v1/branches/{id}/closures',
  'POST /v1/branches/{id}/resources',
  'POST /v1/cash-sessions/close',
  'POST /v1/cash-sessions/movements',
  'POST /v1/cash-sessions/open',
  'POST /v1/channel-accounts',
  'POST /v1/channel-accounts/{id}/test-message',
  'POST /v1/channel-accounts/{id}/verify',
  'POST /v1/channel-accounts/{id}/webhook',
  'POST /v1/channels/instagram/start',
  'POST /v1/channels/messenger/connect',
  'POST /v1/channels/messenger/start',
  'POST /v1/checklists',
  'POST /v1/checklists/{id}/runs',
  'POST /v1/checkout/waiting/{id}/no-charge',
  'POST /v1/clinical/codes',
  'POST /v1/clinical/plans',
  'POST /v1/clinical/plans/{id}/accept',
  'POST /v1/clinical/plans/{id}/bill',
  'POST /v1/clinical/plans/{id}/cancel',
  'POST /v1/clinical/plans/{id}/pdf',
  'POST /v1/clinical/plans/{id}/propose',
  'POST /v1/clinical/records',
  'POST /v1/clinical/records/{id}/amend',
  'POST /v1/clinical/records/{id}/sign',
  'POST /v1/clinical/templates',
  'POST /v1/compensation/simulate',
  'POST /v1/customer-complaints',
  'POST /v1/customer-tags',
  'POST /v1/customer-tags/assign',
  'POST /v1/customer-tags/{id}/merge',
  'POST /v1/customers',
  'POST /v1/customers/{id}/erase',
  'POST /v1/customers/{id}/line-invite',
  'POST /v1/customers/{id}/loyalty/points',
  'POST /v1/customers/{id}/loyalty/redeem',
  'POST /v1/customers/{id}/loyalty/stamps',
  'POST /v1/customers/{id}/loyalty/stamps/remove',
  'POST /v1/customers/{id}/merge',
  'POST /v1/customers/{id}/notes',
  'POST /v1/customers/{id}/packages',
  'POST /v1/customers/{id}/packages/{packageId}/use',
  'POST /v1/daily-closes',
  'POST /v1/deposits',
  'POST /v1/deposits/{id}/forfeit',
  'POST /v1/deposits/{id}/refund',
  'POST /v1/field-definitions',
  'POST /v1/finance/categories',
  'POST /v1/finance/entries',
  'POST /v1/followups',
  'POST /v1/followups/{id}/cancel',
  'POST /v1/followups/{id}/complete',
  'POST /v1/followups/{id}/snooze',
  'POST /v1/goals/copy',
  'POST /v1/goals/split',
  'POST /v1/imports',
  'POST /v1/imports/pos/commit',
  'POST /v1/imports/pos/preview',
  'POST /v1/imports/preview',
  'POST /v1/inventory/categories',
  'POST /v1/inventory/counts',
  'POST /v1/inventory/counts/{id}/cancel',
  'POST /v1/inventory/counts/{id}/post',
  'POST /v1/inventory/imports/commit',
  'POST /v1/inventory/imports/preview',
  'POST /v1/inventory/products',
  'POST /v1/inventory/stock/adjust',
  'POST /v1/inventory/stock/check',
  'POST /v1/inventory/stock/issue',
  'POST /v1/inventory/stock/receive',
  'POST /v1/inventory/stock/transfer',
  'POST /v1/inventory/suppliers',
  'POST /v1/invites',
  'POST /v1/kpi/exports',
  'POST /v1/kpi/recompute',
  'POST /v1/leave-requests',
  'POST /v1/leave-requests/{id}/cancel',
  'POST /v1/leave-requests/{id}/decide',
  'POST /v1/leave-requests/{id}/reassign',
  'POST /v1/manual/exports',
  'POST /v1/me/notifications/read',
  'POST /v1/members',
  'POST /v1/members/{id}/deactivate',
  'POST /v1/members/{id}/invite',
  'POST /v1/members/{id}/login',
  'POST /v1/members/{id}/offboarding',
  'POST /v1/members/{id}/password',
  'POST /v1/message-jobs/{id}/cancel',
  'POST /v1/message-jobs/{id}/send-now',
  'POST /v1/message-templates',
  'POST /v1/message-templates/preview',
  'POST /v1/message-templates/{id}/preview',
  'POST /v1/messages/send',
  'POST /v1/offboardings/{id}/appointments',
  'POST /v1/offboardings/{id}/handover-customers',
  'POST /v1/offboardings/{id}/revoke-access',
  'POST /v1/onboarding/complete',
  'POST /v1/online-booking/deposits/{appointmentId}/confirm',
  'POST /v1/online-booking/deposits/{appointmentId}/reject',
  'POST /v1/online-booking/rich-menu',
  'POST /v1/online-booking/walk-in/regenerate',
  'POST /v1/ops/defaults',
  'POST /v1/package-products',
  'POST /v1/payout-periods',
  'POST /v1/payout-periods/{id}/close',
  'POST /v1/payouts/adjustments',
  'POST /v1/platform/accounting/contacts',
  'POST /v1/platform/accounting/documents',
  'POST /v1/platform/accounting/documents/{id}/convert',
  'POST /v1/platform/accounting/documents/{id}/issue',
  'POST /v1/platform/accounting/documents/{id}/payments',
  'POST /v1/platform/accounting/documents/{id}/pdf',
  'POST /v1/platform/accounting/documents/{id}/quotation-status',
  'POST /v1/platform/accounting/documents/{id}/void',
  'POST /v1/platform/accounting/expense-categories',
  'POST /v1/platform/accounting/expenses',
  'POST /v1/platform/accounting/export/documents-pdf',
  'POST /v1/platform/accounting/items',
  'POST /v1/platform/accounting/payments/{id}/void',
  'POST /v1/platform/accounting/shop-invoices/{id}/pdf',
  'POST /v1/platform/ads/report',
  'POST /v1/platform/ads/sync',
  'POST /v1/platform/assignments',
  'POST /v1/platform/audits',
  'POST /v1/platform/audits/{id}/findings',
  'POST /v1/platform/audits/{id}/report',
  'POST /v1/platform/audits/{id}/rubric-scores',
  'POST /v1/platform/engagements',
  'POST /v1/platform/engagements/{id}/tasks/generate',
  'POST /v1/platform/invoices',
  'POST /v1/platform/invoices/generate',
  'POST /v1/platform/invoices/other',
  'POST /v1/platform/invoices/{id}/confirm-payment',
  'POST /v1/platform/invoices/{id}/pdf',
  'POST /v1/platform/invoices/{id}/reject-slip',
  'POST /v1/platform/invoices/{id}/send',
  'POST /v1/platform/leads',
  'POST /v1/platform/leads/{id}/activities',
  'POST /v1/platform/leads/{id}/convert',
  'POST /v1/platform/page-inbox/check-draft',
  'POST /v1/platform/page-inbox/connect',
  'POST /v1/platform/page-inbox/conversations/{id}/link-tenant',
  'POST /v1/platform/page-inbox/conversations/{id}/send',
  'POST /v1/platform/page-inbox/sync',
  'POST /v1/platform/plans',
  'POST /v1/platform/plans/marketing-preview',
  'POST /v1/platform/sales-ai/broadcast',
  'POST /v1/platform/sales-ai/broadcast/preview',
  'POST /v1/platform/sales-ai/test',
  'POST /v1/platform/team',
  'POST /v1/platform/tenants/{id}/ai-chat/test',
  'POST /v1/platform/tenants/{id}/ai-chat/topup',
  'POST /v1/platform/tenants/{id}/ai-tags',
  'POST /v1/platform/tenants/{id}/business-type',
  'POST /v1/platform/tenants/{id}/demo-data',
  'POST /v1/platform/tenants/{id}/followups',
  'POST /v1/platform/tenants/{id}/impersonate',
  'POST /v1/platform/tenants/{id}/notices',
  'POST /v1/platform/tenants/{id}/rental-reset',
  'POST /v1/platform/users/{id}/revoke-sessions',
  'POST /v1/positions',
  'POST /v1/promptpay/qr',
  'POST /v1/push-subscriptions',
  'POST /v1/push-subscriptions/test',
  'POST /v1/question-bank',
  'POST /v1/ratings/{id}/resolve',
  'POST /v1/rentals',
  'POST /v1/rentals/blocklist',
  'POST /v1/rentals/booking-imports/commit',
  'POST /v1/rentals/booking-imports/preview',
  'POST /v1/rentals/imports/commit',
  'POST /v1/rentals/imports/preview',
  'POST /v1/rentals/items/{id}/condition/{entryId}/resolve',
  'POST /v1/rentals/terms/preview',
  'POST /v1/rentals/{id}/refund',
  'POST /v1/rentals/{id}/security',
  'POST /v1/rentals/{id}/shipment',
  'POST /v1/report-runs',
  'POST /v1/risk/assign-secondary',
  'POST /v1/roles',
  'POST /v1/rules/explain',
  'POST /v1/schedule-blocks',
  'POST /v1/service-categories',
  'POST /v1/service-categories/reorder',
  'POST /v1/service-records',
  'POST /v1/services',
  'POST /v1/services/reorder',
  'POST /v1/services/{id}/duplicate',
  'POST /v1/shift-swap-requests/{id}/cancel',
  'POST /v1/shift-swap-requests/{id}/decide',
  'POST /v1/shift-templates',
  'POST /v1/shifts',
  'POST /v1/shifts/generate',
  'POST /v1/shifts/{id}/swap-requests',
  'POST /v1/skills',
  'POST /v1/sops',
  'POST /v1/sops/{id}/acknowledge',
  'POST /v1/surveys',
  'POST /v1/surveys/{id}/close',
  'POST /v1/surveys/{id}/issue-tokens',
  'POST /v1/surveys/{id}/open',
  'POST /v1/table-orders/counter',
  'POST /v1/table-orders/tables/{resourceId}/orders',
  'POST /v1/table-orders/tables/{resourceId}/token',
  'POST /v1/table-orders/{billId}/collected',
  'POST /v1/table-orders/{billId}/prepay/confirm',
  'POST /v1/table-orders/{billId}/prepay/reject',
  'POST /v1/table-orders/{billId}/ready',
  'POST /v1/table-orders/{billId}/rounds/{round}/printed',
  'POST /v1/table-orders/{billId}/ship',
  'POST /v1/tenant/apply-template',
  'POST /v1/time-off',
  'POST /v1/time-off/{id}/reassign',
  'POST /v1/vacation-tests',
  'POST /v1/vacation-tests/{id}/certificate',
  'POST /v1/vacation-tests/{id}/contacts',
  'POST /v1/vacation-tests/{id}/finish',
  'POST /v1/vacation-tests/{id}/issues',
  'PUT /v1/ai-chat/inbox/prefs',
  'PUT /v1/approval-rules',
  'PUT /v1/branch-insights/digest-setting',
  'PUT /v1/branches/{id}/resources/order',
  'PUT /v1/checkout/settings',
  'PUT /v1/customer-settings',
  'PUT /v1/customers/{id}/followup-state',
  'PUT /v1/customers/{id}/health',
  'PUT /v1/followups/settings',
  'PUT /v1/goals',
  'PUT /v1/goals/settings',
  'PUT /v1/inventory/counts/{id}/lines',
  'PUT /v1/inventory/products/{id}/recipe',
  'PUT /v1/inventory/services/{id}/supplies',
  'PUT /v1/me/photo',
  'PUT /v1/me/pin',
  'PUT /v1/members/{id}/custom-skills',
  'PUT /v1/members/{id}/pin',
  'PUT /v1/members/{id}/skills',
  'PUT /v1/message-plans',
  'PUT /v1/onboarding/owner-contact',
  'PUT /v1/online-booking/services/{id}',
  'PUT /v1/online-booking/settings',
  'PUT /v1/online-booking/staff/{id}',
  'PUT /v1/online-booking/walk-in',
  'PUT /v1/platform/accounting/company',
  'PUT /v1/platform/accounting/documents/{id}',
  'PUT /v1/platform/accounting/expenses/{id}',
  'PUT /v1/platform/addons',
  'PUT /v1/platform/ads/goals',
  'PUT /v1/platform/audits/{id}/action-plan',
  'PUT /v1/platform/sales-ai/config',
  'PUT /v1/platform/tenants/{id}/extras',
  'PUT /v1/platform/tenants/{id}/limits',
  'PUT /v1/platform/tenants/{id}/modules',
  'PUT /v1/platform/tenants/{id}/trial',
  'PUT /v1/ratings/settings',
  'PUT /v1/rentals/{id}/return-method',
  'PUT /v1/report-subscriptions',
  'PUT /v1/rules/booking',
  'PUT /v1/rules/compensation',
  'PUT /v1/rules/discount',
  'PUT /v1/rules/pay-method',
  'PUT /v1/scheduling/reminder-settings',
  'PUT /v1/shifts/bulk',
  'PUT /v1/tenant/logo',
  'PUT /v1/tenant/receiving-accounts',
  'PUT /v1/tenant/shifts',
  'PUT /v1/tenant/terminology',
  'PUT /v1/watchdog/settings',
];
